import React from 'react';
import Modal from 'shared/components/modal';
import Image1 from 'shared/img/video-welcome-image.svg';

type SvgComponent = React.FC<React.SVGProps<SVGSVGElement>>;

interface ModalContent {
  title: string;
  text: string;
  ModalImage: SvgComponent;
}

interface Props {
  handleClose: () => void;
}

const VideoModal = ({handleClose}: Props) => {
  const modalContent = {} as ModalContent;

  modalContent.title = 'Welcome to Video Education';
  modalContent.text =
    "Here's where you can explore informative videos that provide valuable insights into the financial aid process.";
  modalContent.ModalImage = Image1;

  return (
    <Modal show className="welcome-modal" onClose={handleClose}>
      <Modal.ImageHeader
        onClose={handleClose}
        backgroundImage={modalContent.ModalImage}
        backgroundColor="b200"
        color="white"
        height="tall"
      >
        {modalContent.title}
      </Modal.ImageHeader>
      <Modal.Body>{modalContent.text}</Modal.Body>
      <Modal.Footer
        primaryButton={{
          onClick: handleClose,
          width: 85,
          text: 'Done',
        }}
      />
    </Modal>
  );
};

export default VideoModal;
